<route>
{
  "name": "courseAdd",
  "meta": {
    "order": 3,
    "isVisible": false,
    "iconName": "mdi-pen"
  }
}
</route>
<template>
  <div>
    <page-title
      :title="$t('pages.course_add.title')">
      <v-btn
        outlined
        @click="$router.go(-1)"
        color="secondary">
        {{$t('general.back')}}
      </v-btn>
    </page-title>
    <v-form
      v-model="formIsValid"
      class="form-horizontal"
    >
      <form-item
        v-model="formData.name"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textarea"
        :rows="2"
        icon="mdi-form-textbox"
        :label="$t('models.name')"
        :placeholder="$t('models.name')"
      ></form-item>
      <form-item
        v-model="formData.description"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textarea"
        :rows="6"
        icon="mdi-form-textbox"
        :label="$t('models.description')"
        :placeholder="$t('models.description')"
      ></form-item>
      <form-item
        v-model="formData.order"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="number"
        icon="mdi-form-textbox"
        :label="$t('models.order')"
        :placeholder="$t('models.order')"
      ></form-item>
      <form-item
        v-model="formData.image"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textbox"
        icon="mdi-form-textbox"
        :label="$t('models.image')"
        :placeholder="$t('models.image')"
      ></form-item>
      <form-item
        v-model="formData.draft"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="checkbox"
        icon="mdi-form-textbox"
        :label="$t('models.draft')"
        :placeholder="$t('models.draft')"
      ></form-item>
      <form-item
        v-model="formData.enable"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="checkbox"
        icon="mdi-form-textbox"
        :label="$t('models.enable')"
        :placeholder="$t('models.enable')"
      ></form-item>
      <form-action>
        <v-btn
          :disabled="!formIsValid"
          color="success"
          depressed
          @click="onSubmitForm"
        >
          {{ $t('pages.forms.submitButtonText') }}
        </v-btn>
        <v-btn
          color="secondary"
          depressed
          outlined
          @click="$router.go(-1)"
        >
          {{ $t('pages.forms.cancelButtonText') }}
        </v-btn>
      </form-action>
    </v-form>
  </div>
</template>

<script>
export default {
  layout: APP_CONFIG.layout.mainPanelLayout,
  data: () => ({
    formIsValid: true,
    formData: {
      name: '',
      description: '',
      draft: true,
      enable: true,
      order: 0,
      image: '',
    }
  }),
  computed: {
  },
  methods: {
    add () {
      this.$store.dispatch('course/add', {
        id: this.$route.params.id,
        name: this.formData.name,
        draft: this.formData.draft,
        enable: this.formData.enable,
        description: this.formData.description,
        order: this.formData.order,
        image: this.formData.image,
      }).then((response) => {
        this.$router.go(-1)
      })
    },
    // NOTE: Keep this name same in all form pages and components
    onSubmitForm () {
      this.add()
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
